import { COLORS } from '@Commons';
import styled from 'styled-components';

export const ShimmerSectionContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  .section-top-container {
    width: 100%;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid ${COLORS.borderGrey};
    padding-bottom: 8px;
  }
  .section-top-container__info-container {
    display: flex;
    gap: 8px;
    flex-direction: column;
    .info-container__row {
      display: flex;
      gap: 8px;
    }
  }
`;
